import { useRouteShellContext } from "@components/routeShellContext"
import { BigHeading, SiteShell } from "@components/SiteShell"
import WorkDetails from "@components/WorkDetails"
import { workPageQueryOptions } from "@data/publicPageDataQuery"
import * as m from "@paraglide/messages"
import type { WorkPageData } from "@site-types/publicPageData"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { isSupportedLocale } from "@utils/locale"
import { localizedRouteHead } from "@utils/routeHead"

export const Route = createFileRoute("/$locale/work")({
  beforeLoad: ({ params }) => {
    if (!isSupportedLocale(params.locale)) throw redirect({ to: "/404" })
  },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(workPageQueryOptions(params.locale as "en" | "ja")),
  head: ({ params }) => {
    const locale = params.locale as "en" | "ja"
    return localizedRouteHead({ locale, page: "work", path: `/${locale}/work` })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const data = Route.useLoaderData()
  return (
    <SiteShell>
      <WorkPage data={data} />
    </SiteShell>
  )
}

export function WorkPage({ data }: { data: WorkPageData }) {
  const { locale } = useRouteShellContext()

  return (
    <>
      <BigHeading variant="h1">
        {(m.work_heading_label({}, { locale: locale }) || "Our Work").toUpperCase()}
      </BigHeading>
      <WorkDetails data={data} />
    </>
  )
}
